import { useContext, useEffect, useMemo, useRef, useState } from "react"
import { useSelector } from "react-redux"
import { Button } from "@nextui-org/react"
import { faAngleDoubleDown, faArrowDown, faArrowDown19, faChevronDown, faCircleChevronDown, faSortDown, faSquareCaretDown } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import { LayoutContext } from "../../contexts/LayoutContext.jsx"
import { sideNavLinks } from "../../constants/enum.js"
import SideNavItem from "./SideNavItem.jsx"


function SideNav() {
  const { showSideNav } = useContext(LayoutContext)
  const { setShowSideNav } = useContext(LayoutContext)
  const { menu } = useSelector((state) => state.auth)
  const { isMultipleCompany } = useSelector((state) => state.company)
  const navRef = useRef()
  const [searchItem, setSearchItem] = useState("")


  let userMenuComponent = useMemo(
    () =>
      menu?.userMenu?.map((item) => {
        if (item.controller !== null) return item.controller
        else return item.menuname
      }),
    [menu.userMenu]
  )

  //hide side bar  when click outside of  side bar 
  const handleClickOutside = (event) => {
    if (
      navRef.current &&
      !navRef.current.contains(event.target)
    ) {
      setShowSideNav(false)
    }
  };

  const filterMenu = (menuList, query) => {
    const lowerQuery = query.toLowerCase();

    const filterRecursive = (items) => {
      return items
        .map((item) => {
          // Filter submenus recursively
          let filteredSub = [];
          if (item.sub && Array.isArray(item.sub)) {
            filteredSub = filterRecursive(item.sub);
          }

          const isMatch = item.name.toLowerCase().includes(lowerQuery);

          if (isMatch || filteredSub.length > 0) {
            return {
              ...item,
              sub: filteredSub.length > 0 ? filteredSub : item.sub,
            };
          }

          return null;
        })
        .filter(Boolean); // Remove nulls
    };

    return filterRecursive(menuList);
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [navRef]);

  const [show, setShow] = useState({ 0: false })
  const [showSub, setShowSub] = useState({ 0: false })


  const SideNavMenu = useMemo(() => {
    if (searchItem && searchItem != "")
      return filterMenu(sideNavLinks, searchItem);
    else
      return sideNavLinks
  }, [searchItem]);

  return (
    <div ref={navRef}>
      <aside

        id="logo-sidebar"
        className={` ${!showSideNav ? "-translate-x-full" : ""
          } fixed top-0 left-0 z-40 w-60 h-screen pt-12 transition-transform border-t-2 border-gray-100 
        border-r border-gray-200 bg-sky-900 `}
        // lg:translate-x-0 
        aria-label="Sidebar"
      >
        <div className=" h-full shadow-[-1px_6px_12px_3px_rgba(0,_0,_0,_0.2)] bg-white overflow-y-auto  ">
        <div className="bg-slate-50 pb-2  border-0 ">
          <input type="text" placeholder="Search..."
            onChange={(e) => setSearchItem(e.target.value)}
            className="  mt-2 mx-5 border-1 border-gray-200 text-xs rounded-0   px-2 py-1" ></input>
        </div>
        <div className="  px-3 pb-4  
    
       ">

          {/* //bg-custom-nav-bg-color bg-custom-nav-bg-color  */}
          <ul className="space-y-2 font-medium pt-2">
            {SideNavMenu.map((item, index) => {
              return item && item.sub ? (
                userMenuComponent?.includes(item.key) ? (isMultipleCompany && (item.key == "Master" || item.key == "Transaction" ||
                  item.key == "OtherTransaction" ||  
                  item.key == "SaleEntryMaster" || item.key == "PurchaseEntryMaster" || item.key == "InterestCalculation")) ? "" : (
                  <li key={index}>
                    <Button
                      radius="none"
                      variant="light"
                      startContent={
                        item && item?.icon && <FontAwesomeIcon className=" " icon={item.icon} />
                      }
                      endContent={<FontAwesomeIcon className="text-xs" icon={faChevronDown} />}
                      onPress={() => {
                        setShow((prev) => ({
                          // ...prev,
                          [index]: !prev[index],
                        }))
                      }}

                      className={` h-7 text-sm w-full  border-l-2 border-orange-600  flex justify-start  text-sky-900  bg-white
                    hover:bg-gradient-to-r from-sky-700 to-slate-50 hover:text-white`}


                    >
                      {/* bg-custom-nav-bg-color text-custom-nav-text-color  hover:bg-custom-bg-light hover:text-white */}
                      {item.name}
                    </Button>
                    <ul
                      className={` ${show[index] ? "block" : "hidden"
                        } py-1 space-y-1`}
                    >
                      {item?.sub.map((subItem, j) => {
                        return item?.sub && subItem.sub ? (userMenuComponent?.includes(subItem.key) ?
                          (isMultipleCompany && (subItem.key == "InterestCalculation")) ? "" :
                            <li key={j}>
                              <Button
                                radius="none"
                                variant="light"
                                startContent={
                                  subItem && subItem?.icon && <FontAwesomeIcon className="text-red-700  text-sm text-red-700" icon={subItem.icon} />
                                }
                                endContent={<FontAwesomeIcon icon={faChevronDown} />}
                                onPress={() => {
                                  setShowSub((prev) => ({
                                    // ...prev,
                                    [j]: !prev[j],
                                  }))
                                }}
                                className="ml-1 h-7 text-sm w-full bg-gradient-to-r from-red-100 to-slate-50 text-red-700  border-l-0 border-red-600  flex justify-start    
                        "
                              >
                                {/*  hover:bg-gradient-to-r from-sky-700 to-slate-50 hover:text-white bg-custom-nav-bg-color text-custom-nav-text-color  hover:bg-custom-bg-light hover:text-white */}
                                {subItem.name}
                              </Button>

                              <ul
                                className={`${showSub[j] ? "block" : "hidden"
                                  } py-1 space-y-2`}
                              > {subItem?.sub.map((nestItem, k) => {
                                return userMenuComponent?.includes(nestItem.key) ? (
                                  <SideNavItem customeclass={" h-7 text-gray-900 bg-orange-250 text-sm border-b-0 border-dashed border-gray-100 hover:bg-gradient-to-r from-gray-600 to-slate-50 hover:text-white"}
                                    navItem={nestItem} key={k} />
                                ) : (
                                  ""
                                )
                              })}
                              </ul>
                            </li>
                          : ("")) :
                          userMenuComponent?.includes(subItem.key) ? (isMultipleCompany && (subItem.key == "GrayProductionEntry")) ? "" : (
                            <SideNavItem customeclass={" h-7 text-orange-600 bg-orange-250  border-b-0 border-dashed border-gray-100 hover:bg-gradient-to-r from-orange-600 to-slate-50 hover:text-white"} navItem={subItem} key={j} />
                          ) : (
                            ""
                          )
                      })}
                    </ul>
                  </li>
                ) : (
                  ""
                )
              ) : userMenuComponent?.includes(item.key) ? (isMultipleCompany && (item.key == "Ledger44")) ? "" : (
                <SideNavItem customeclass={''} navItem={item} key={index} />
              ) : (
                ""
              )
            })}
          </ul>
        </div>
        </div>
      </aside>
    </div>
  )
}

export default SideNav
